import { useInvalidateOnboardingStatus } from '../../hooks/useOnboarding';
import { CompanyProfileForm } from '../settings/CompanyProfileSettings';

/**
 * Onboarding wizard — step 1 "Compania ta" (SaaS hardening). Reuses the shared
 * company-profile form; a successful save flips `steps.companyProfile` behind
 * GET /api/onboarding/status.
 */
export function StepCompanyProfile() {
  const invalidateStatus = useInvalidateOnboardingStatus();

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900">Compania ta</h2>
      <p className="mt-1 text-sm text-gray-500">
        Completează datele firmei — ele apar în brandul aplicației, în emailuri și pe facturi.
        Introdu CUI-ul și preia automat datele de la ANAF.
      </p>
      <div className="mt-4">
        <CompanyProfileForm onSaved={invalidateStatus} />
      </div>
    </div>
  );
}
